import * as React from 'react';
import { createBrowserRouter } from 'react-router';
import Loader from 'components/Loader';
import ErrorBoundary from './ErrorBoundary';
import { CustomerFacingError } from 'utils/ui/errors';
import { customerRoutes } from './routes/customer';
import { dealerRoutes } from './routes/dealer';
import { universalSessionLoader } from './universalSessionLoader';
import { applyDealerEntrance } from './dealerEntranceBootstrap';

const Auth = React.lazy(() => import('components/Auth'));
const AuthResume = React.lazy(() => import('components/Auth/AuthResume'));

// AVS-4405: must run before createBrowserRouter starts the initial navigation and its loaders. This
// line is the only place provably ahead of every loader, the gate and the sign-in callback.
applyDealerEntrance();

export const router = createBrowserRouter([
  {
    path: '/auth',
    element: (
      <React.Suspense fallback={<Loader />}>
        <Auth />
      </React.Suspense>
    ),
  },
  {
    path: '/auth/resume',
    element: (
      <React.Suspense fallback={<Loader />}>
        <AuthResume />
      </React.Suspense>
    ),
  },
  {
    path: '/:sessionId',
    element: <React.Fragment />,
    errorElement: <ErrorBoundary />,
    loader: universalSessionLoader,
  },
  {
    path: '/',
    hydrateFallbackElement: <></>,
    errorElement: <ErrorBoundary />,
    children: [...dealerRoutes, ...customerRoutes],
  },
  {
    path: '*',
    errorElement: <ErrorBoundary />,
    loader: async () => {
      throw new CustomerFacingError(404);
    },
  },
]);
